import React from 'react';
import ReactDOM from 'react-dom';
import "./scss/ekart.scss";
import { Provider } from 'react-redux';
// import { createStore, applyMiddleware } from 'redux';
// import thunk from 'redux-thunk';
// import rootReducer from './reducers';
import App from "./components/App";
import store from './store/store';

//const store = createStore(rootReducer, applyMiddleware(thunk));

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>
  ,
  document.getElementById('root')
);

// Keep one persistent root service worker for Firebase background messages.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  navigator.serviceWorker.register('/firebase-messaging-sw.js', { scope: '/' })
    .then(registration => {
      console.log('Firebase Service Worker registered with scope:', registration.scope);
      registration.update();
    })
    .catch(error => {
      console.error('Firebase Service Worker registration failed:', error);
    });
}
